<section class="login-page">
  <div class="login-form-container">
    <h2>Belépés</h2>

    <ngb-alert *ngFor="let m of msgs" [type]="m.severity" (close)="closeAlert(m)">
      <strong>{{m.summary}}</strong> {{m.details}}
    </ngb-alert>

    <form (submit)="doLogin()">
      <div class="form-group row">
        <label for="email" class="col-lg-3 col-form-label">Email:</label>
        <div class="col-lg-9">
          <input type="text"
                 id="email"
                 name="email"
                 [class.missing]="error && !credentials.email"
                 placeholder="Felhasználónév"
                 [(ngModel)]="credentials.email"
                 class="form-control"
                 #emailField
          />
        </div>
      </div>
      <div class="form-group row">
        <label for="password" class="col-lg-3 col-form-label">Jelszó:</label>
        <div class="col-lg-9">
          <input type="password"
                 id="password"
                 name="password"
                 [class.missing]="error && !credentials.password"
                 placeholder="Jelszó"
                 [(ngModel)]="credentials.password"
                 class="form-control"
                 #passwordField
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3"></div>
        <div class="col-lg-9 submit">
          <button type="submit"
                  [disabled]="pending"
                  class="btn btn-success"
          ><i class="fa fa-sign-in"></i> Bejelentkezés</button>
        </div>
      </div>
    </form>
  </div>
</section>



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/auth/login/login.component.html